<template>
	<el-carousel class="mediaCarousel" :interval="5000" arrow="never">
		<el-carousel-item v-for="(display, i) in displays" :key="i">
			<h1 :style="display.headingCustomStyles">{{ display.heading }}</h1>
			<p :style="display.subHeadingCustomStyles">{{ display.subHeading }}</p>
			<img :style="display.imgCustomStyles" :src="display.img" />
			<div v-if="display.showBlur" class="blur"></div>
		</el-carousel-item>
	</el-carousel>
</template>

<script>
import collage from "../assets/integrationCollage.svg";
export default {
	data() {
		return {
			displays: [
				{
					heading: "Build Any Workflow With 350+ Integrations",
					headingCustomStyles: { marginTop: "12%", zIndex: 1, position: "relative" },
					subHeading: "Endless automation in just a few clicks",
					subHeadingCustomStyles: { zIndex: 1, position: "relative" },
					img: collage,
					imgCustomStyles: { width: "100%", marginTop: "40px" },
					showBlur: true,
				},
			],
		};
	},
};
</script>

<style scoped>
.mediaCarousel {
	padding: 40px;
	height: 100%;
	box-sizing: border-box;
	text-align: center;
	background-color: #f5f7f9;
}

h1,
p {
	text-align: left;
}

.blur {
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	width: 200px;
	background-image: linear-gradient(to left, rgba(255, 0, 0, 0), #f5f7f9);
	z-index: 0;
}
</style>
